// extracted by mini-css-extract-plugin
export default {"closeButton":"Close_closeButton__-wmNm"};